import { mdiAlertCircle, mdiCursorMove, mdiDelete } from '@mdi/js'

export default {
  'freshvueforms-error': mdiAlertCircle,
  'freshvueforms-drag': mdiCursorMove,
  'freshvueforms-delete': mdiDelete
}
